import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';

export const ClaimGroupActivityService = {
  all (claimGroupId) {
    return fetch('/api/claim_groups/' + claimGroupId + '/claim_activities', request.get);
  }
};